import { CalendarClock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Spinner } from "@/components/ui/spinner";
import { useBackupSchedule } from "@/features/backups/hooks/useBackupsQueries";
import { formatOptionalArabicDateTime } from "@/lib/formatters";

export function ScheduleCard() {
  const { data, isLoading } = useBackupSchedule();

  return (
    <Card dir="rtl">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <CalendarClock className="size-5 text-muted-foreground" />
            <CardTitle className="text-base">النسخ الاحتياطي التلقائي اليومي</CardTitle>
          </div>
          {!isLoading && data && (
            <Badge variant={data.enabled ? "default" : "secondary"}>
              {data.enabled ? "مُفعّل" : "متوقف"}
            </Badge>
          )}
        </div>
        <CardDescription>
          جدولة تعمل على الخادم لإنشاء نسخة احتياطية يومياً.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex justify-center py-4">
            <Spinner className="size-5" />
          </div>
        ) : (
          <dl className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-3">
            <div>
              <dt className="text-muted-foreground">جدول التشغيل (cron)</dt>
              <dd className="font-mono" dir="ltr">
                {data?.cron ?? "—"}
              </dd>
            </div>
            <div>
              <dt className="text-muted-foreground">المنطقة الزمنية</dt>
              <dd>{data?.timezone ?? "—"}</dd>
            </div>
            <div>
              <dt className="text-muted-foreground">آخر تشغيل تلقائي</dt>
              <dd>{formatOptionalArabicDateTime(data?.lastRunAt)}</dd>
            </div>
          </dl>
        )}
      </CardContent>
    </Card>
  );
}
